/**
 * Closed set of platform button keyboard shortcuts.
 * Mod = Ctrl on Windows/Linux, Meta (⌘) on macOS.
 *
 * Mod+K is intentionally absent — the AI assistant owns that shortcut outside
 * this registry.
 */
export enum KeyboardShortcut {
  ModS = 'ModS',
  ModEnter = 'ModEnter',
}
